import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'redaction'
import actions from 'redux/actions'
import { FormattedHTMLMessage } from 'sb-react-intl'
import { links, mixpanel, constants } from 'common/helpers'

import Modal from 'components/modal/Modal/Modal'
import Button from 'components/buttons/Button/Button'

import messages from './messages'
import s from './SkincareModal.scss'


class SkincareModal extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    gender: PropTypes.oneOf([ 'male', 'female' ]),
  }

  static defaultProps = {
    name: constants.modals.newProducts.Skincare,
  }

  componentDidMount() {
    mixpanel.track(constants.analyticsEvents.popupSkincare)
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
    this.updateClosedPopup()
  }

  updateClosedPopup = () => {
    const { name } = this.props

    actions.models.ui.setClosedPopup(name)
  }

  handleButtonClick = () => {
    this.close()
    mixpanel.track(constants.analyticsEvents.popupSkincareClick)
  }

  render() {
    const { name, gender } = this.props

    const titleMessage = gender === 'male' ? messages.titleMen : messages.titleWomen

    return (
      <Modal
        className={s.modal}
        name={name}
        title={titleMessage}
        titleClassName={s.title}
        titleUppercase
        onClose={this.updateClosedPopup}
      >
        <FormattedHTMLMessage tag="div" {...messages.text} values={{ gender }} />
        <div className={s.buttonContainer}>
          <Button
            title={messages.buttonTitle}
            to={links.skincare}
            md
            brand
            onClick={this.handleButtonClick}
          />
        </div>
      </Modal>
    )
  }
}


export default connect({
  gender: 'models.me.gender',
})(SkincareModal)
